import { Component, Input, Output, EventEmitter, Pipe, PipeTransform, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AvatarSearchModel } from '../models/avatar-search';
import { CoreService, HttpService } from '../services';

@Pipe({
  name: 'avatarSearchRenderer'
})
export class RendererPipe implements PipeTransform {

  constructor() { }
  /**
   *  affiche les differents éléments et listes dans une liste (sous forme de blocs) afin de pouvoir être rendus dans le cdkVirtualFor
   * @param selectedList éléménets sélectionnés
   * @param elementList liste de tous les éléments
   * @param inputValue valeur saisie pour le filtre
   * @param nullable
   * @param multipleSelection
   * @param labelPropName
   * @param identPropName
   */
  transform(elementList: Array<any>, selectedList: Array<any>, inputValue: string, nullable: boolean, multipleSelection: boolean, labelPropName: string, identPropName: string): Array<any> {
    let lstLines: Array<any> = new Array<any>();

    //#region booléens qui affichent les éléments spécifiques aux modes nullable et multiple
    //éléments sélectionnés
    const displaySelectedElementstGroup: boolean = (selectedList && selectedList.length > 0) && (nullable || multipleSelection);
    // compteur d'éléments restants et éventuellement le bouton "Ajouter tous"
    const displayUnselectedHeaderGroup: boolean = (elementList && elementList.length > 0 && elementList.length != selectedList.length) && (nullable || multipleSelection);
    //#endregion

    if (displaySelectedElementstGroup) {
      //#region éléments sélectionnés
      // bloc en-tête (contient le  compteur d'éléments sélectionnés et le bouton "Retirer tous")
      lstLines.push({ NameElementToRender: 'selectedElements', TypeElementToRender: 'Header' });
      // blocs corps (liste des éléments sélectionnés)
      selectedList.forEach((element: any, i: number) => {
        element.TypeElementToRender = 'Body';
        element.NameElementToRender = 'selectedElements';
      });
      //on filtre les éléments sélectionnés par rapport à l'inputValue avant de les pousser dans le rendu.
      lstLines = lstLines.concat(this.Filter(selectedList, inputValue, labelPropName, identPropName));
      lstLines.push({ NameElementToRender: 'selectedElements', TypeElementToRender: 'Hr' });
      //#endregion
    }
    if (displayUnselectedHeaderGroup) {
      lstLines.push({ NameElementToRender: 'unselectedElements', TypeElementToRender: 'Header' });
    }
    //#region éléments non sélectionnés
    elementList.forEach((element: any, i: number) => {
      element.TypeElementToRender = 'Body';
      element.NameElementToRender = 'unselectedElements';
    });
    // liste des éléments filtrée par rapport à l'inputValue et sans les éléments sélectionnés
    lstLines = lstLines.concat(this.Filter(elementList, inputValue, labelPropName, identPropName, selectedList));
    //#endregion
    return lstLines;
  }

  /**
   * filtre la première liste passée en paramètre en retirant les éléments:
   * ne contenant pas "value" dans leur "labelPropName"
   * se trouvant déjà dans la sélected liste (paramètre optionnel)
   * @param elementList liste à filtrer
   * @param value saisie dans la barre de recherche
   * @param labelPropName
   * @param identPropName
   * @param selectedList élements sélectionnés
   */
  public Filter(elementList: Array<any>, value: string, labelPropName: string, identPropName: string, selectedList: Array<any> = []): Array<any> {
    let filteredList: Array<any> = JSON.parse(JSON.stringify(elementList));

    if (!filteredList || filteredList.length == 0) { return []; }
    if ((!selectedList || selectedList.length == 0) && !value) { return filteredList; }    

     //#region retire les élements sélectionnés (si passés en paramètre)
    selectedList.forEach(selectedElement => {
      const index: number = filteredList.findIndex((x: any) => x[identPropName] === selectedElement[identPropName]);
      if (index > -1) {
        filteredList.splice(index, 1);
      }
    })
     //#endregion
      //#region retire les élément ne contenant pas la chaine saisie en barre de recherche
    if (value)
      filteredList = filteredList.filter(element => element[labelPropName].toLowerCase().includes(value.toLowerCase()));
      //#endregion

    return filteredList;
  }

}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-avatar-search',
  templateUrl: './avatar-search.component.html',
  styleUrls: ['./avatar-search.component.css'],
  providers: [RendererPipe]
})

export class AvatarSearchComponent implements OnInit {

  public placement: string = 'bottom';

  public placeholder: string = 'Rechercher...';

  public value: Array<any> = [];

  public selectedList: Array<any> = new Array<any>();

  public inputValue: string = '';

  public multipleSelection: boolean = false;
  public nullable: boolean = true;
  
  private mode: string = '';
  private maxPopoverWidth: number = 0;

  //Mode autonome pour construire la liste des objets:
  // COLLAB => liste des collaborateurs
  //
  @Input('mode') set SetMode(value: string) {
    this.mode = value;
  }

  //#region Inputs obligatoires (mode par defaut)

  //liste d'objets à filtrer
  @Input() elementList: Array<any> = new Array<any>();
  //nom de la propriété de l'objet où est stocké le texte à afficher
  @Input() labelPropName: string;
  //ident unique qui sert à dissocier les différents éléménts de la liste
  @Input() identPropName: string;
  //nom de la propriété de l'objet où est stocké l'image à afficher
  //(si non renseigné utilisera les initiales de labelPropName)
  @Input() imgPropName: string;

  //#endregion

  //#region Inputs optionnels (paramètres)

  // Valeur par defaut de la liste selectionné lors de l'initialisation
  @Input('value') set Value(value: Array<any>) {
    this.value = value;
  }

  // Autorise la selection multiple d'element
  @Input('multipleSelection') set MultipleSelection(value: boolean) {
    this.multipleSelection = value;
  }

  // Autorise la liste des elements selectionnes d'être vide
  @Input('nullable') set Nullable(value: boolean) {
    this.nullable = value;
  }
 
  //#endregion

  //#region Output

  @Output('selectedList') selectedListEmitter: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  //#endregion




  constructor(
    public domSanitizer: DomSanitizer,
    protected FilterPipe: RendererPipe,
    protected cd: ChangeDetectorRef,
    private indParam: CoreService,
    private http: HttpService,
  ) { }

  ngOnInit(): void {
    switch (this.mode) {
      case 'COLLAB':
        //faire l'appel serv puis affecter le retour a lst
        this.http.getHttp<AvatarSearchModel>(`${this.indParam.AppParams.apiUrl}api/avatarSearch/getData/${this.mode}/0`).subscribe((data: AvatarSearchModel) => {
          this.elementList = data.ListCollabo;

          this.identPropName = 'Id';
          this.labelPropName = 'Value';
          this.imgPropName = 'ProfilePicture';

          this.AddElement(this.value, null);
        });
        break;

      default:
        this.AddElement(this.value, null);
        break;
    }
  }

  public getUrl(url: string): string {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url) as string;
  }

  //#region Ajout et Suppression des elements dans les listes selectionné et non selectionné

  public AddElement(values: Array<any>, popover: any): void {
    if (values && values.length > 0) {
      // Selection unitaire
      if (!this.multipleSelection) {
        // on vide la liste comme ça lors de l'ajout il n'y a qu'un seul élément sélectionné
        this.selectedList = new Array<any>();
        if (popover) {
          popover.close();
        }
      }

      // Ajout de l'element selectionné
      if (this.elementList && this.elementList.length > 0) {
        const selectedValues = this.elementList.filter(x => values.includes(x[this.identPropName]));
        // si la valeur est erronée mais que le composant est non nullable on retourne l'élément 0 de la liste
        if (!this.nullable && selectedValues.length != this.elementList.length) {
          this.selectedList = this.selectedList.concat(selectedValues.length == 0 ? this.elementList[0] : selectedValues);         
        } else {
          this.selectedList = this.selectedList.concat(selectedValues);
        }
      }
      else {
        this.selectedList = new Array<any>();
      }

      // Emission de la liste selectionne (conditionné pour ne pas émettre la liste à l'initialisation)      
      this.selectedListEmitter.emit(this.selectedList);
    }
  }
  public RemoveElement(value: string, popover: any): void {
    //empêche la suppression du dernier élément sélectionné si non nullable
    if (this.nullable || (!this.nullable && this.selectedList && this.selectedList.length > 1)) {
      const index: number = this.selectedList.findIndex(x => x[this.identPropName] === value);
      this.selectedList.splice(index, 1);
      // sert à forcer la modification de la liste pour que le pipe avatarSearchRenderer soit triggered
      this.selectedList = JSON.parse(JSON.stringify(this.selectedList));
      if (!this.multipleSelection && popover) {
        popover.close();
      }
      this.selectedListEmitter.emit(this.selectedList);
    }
  }

  public RemoveAll() {
    // garde fou si jamais non nullable
    const elementKeeped = JSON.parse(JSON.stringify(this.selectedList[0]));
    //récupère la liste filtrée pour ne retirer que ces éléments plutot que la liste entière
    const selectedListFiltred = this.FilterPipe.Filter(this.selectedList, this.inputValue, this.labelPropName, this.identPropName, []);
    //retire les éléments de la liste filtrée en se basant sur l'ident
    this.selectedList = JSON.parse(JSON.stringify(this.selectedList.filter(s => selectedListFiltred.findIndex(e => e[this.identPropName] === s[this.identPropName]) < 0)));
    //remet l'elementKeeped si non nullable
    if (!this.nullable && this.multipleSelection && this.selectedList && this.selectedList.length < 2) {
      this.selectedList.push(elementKeeped);
    }
    this.selectedListEmitter.emit(this.selectedList);
  }
  public AddAll() {
    // concatène la selectedList avec la liste filtrée des éléments non sélectionnés (plutot que la liste entière)
    this.selectedList = JSON.parse(JSON.stringify(this.selectedList.concat(this.FilterPipe.Filter(this.elementList, this.inputValue, this.labelPropName, this.identPropName, this.selectedList))));
    this.selectedListEmitter.emit(this.selectedList);
  }

  //#endregion

  // Liste des elements selectionnés pour le tooltip
  public GetListElement(): string {
    let elements: string = '';
    this.selectedList.forEach((item: any) => {
      elements = item && item[this.labelPropName] ? elements ? `${elements}\n${item[this.labelPropName]}` : item[this.labelPropName] : elements;
    });

    return elements;
  }

  // Calcul de la largeur de la liste
  public SetCdkViewportWidth(cdkViewportContainer: any): string {
    this.cd.detectChanges();
    if (cdkViewportContainer && cdkViewportContainer.firstChild && cdkViewportContainer.firstChild.firstChild && cdkViewportContainer.firstChild.firstChild.offsetWidth && cdkViewportContainer.firstChild.firstChild.offsetWidth >= 235) {
      if (cdkViewportContainer.offsetWidth > (this.maxPopoverWidth + 10))
        this.maxPopoverWidth = cdkViewportContainer.firstChild.firstChild.offsetWidth + 10;
      return `${this.maxPopoverWidth}px`;
    }

    return '';
  }
}
